<script setup lang="ts">
import type { TitleType } from './bootstrap-panel';
import BootstrapPanel from './bootstrap-panel.vue';
import type { WizardNavigation } from './wizard-page';

const props = defineProps<{
    title?: string | boolean;
    titleType?: TitleType;
    navigation: WizardNavigation;
}>();

const emit = defineEmits<{
    (event: 'prev'): void;
    (event: 'next'): void;
    (event: 'finish'): void;
    (event: 'cancel'): void;
}>();
</script>

<template>
    <BootstrapPanel :title="props.title" :title-type="props.titleType" footer>
        <slot />
        <template #footer>
            <div class="btn-group" role="group">
                <button
                    :class="props.navigation.hasPrevPage ? '' : 'hidden-control'"
                    :disabled="!props.navigation.backwardNavigationEnabled"
                    type="button"
                    class="btn btn-default"
                    @click="emit('prev')"
                >
                    Precedente
                </button>
                <button
                    :class="props.navigation.hasNextPage ? '' : 'hidden-control'"
                    :disabled="!props.navigation.forwardNavigationEnabled"
                    type="button"
                    class="btn btn-primary"
                    @click="emit('next')"
                >
                    Avanti
                </button>
            </div>
            <div class="btn-group" role="group">
                <template v-if="props.navigation.hasNextPage">
                    <a
                        v-if="props.navigation.cancelUrl"
                        :class="props.navigation.cancelEnabled ? '' : 'hidden-control'"
                        class="btn btn-default"
                        :href="props.navigation.cancelUrl"
                        role="button"
                    >
                        Annulla
                    </a>
                    <button
                        v-else
                        :disabled="!props.navigation.cancelEnabled"
                        type="button"
                        class="btn btn-default"
                        @click="emit('cancel')"
                    >
                        Annulla
                    </button>
                </template>
                <template v-else>
                    <a
                        v-if="props.navigation.finishUrl"
                        class="btn btn-default"
                        :href="props.navigation.finishUrl"
                        role="button"
                    >
                        Fine
                    </a>
                    <button
                        v-else
                        type="button"
                        class="btn btn-default"
                        @click="emit('finish')"
                    >
                        Fine
                    </button>
                </template>
            </div>
        </template>
    </BootstrapPanel>
</template>

<style scoped>
.hidden-control {
    visibility: hidden;
}
</style>
